type IconProps = { className?: string }

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

export function DashboardIcon({ className }: IconProps) {
  return (
    <svg {...base} className={className}>
      <rect x="3" y="3" width="7.5" height="7.5" rx="1.25" />
      <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.25" />
      <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.25" />
      <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.25" />
    </svg>
  )
}

// Silhouette de fût plutôt qu'une icône générique — le vocabulaire visuel
// doit rester celui du métier (cf. DESIGN.md).
export function KegIcon({ className }: IconProps) {
  return (
    <svg {...base} className={className}>
      <path d="M8.5 3h7l1 3.2c.75 2.2.75 9.4 0 11.6L15.5 21h-7l-1-3.2c-.75-2.2-.75-9.4 0-11.6L8.5 3Z" />
      <path d="M7.6 8.4h8.8M7.6 15.6h8.8" />
    </svg>
  )
}

export function EstablishmentIcon({ className }: IconProps) {
  return (
    <svg {...base} className={className}>
      <path d="M12 21s7-6.7 7-11.8A7 7 0 0 0 5 9.2C5 14.3 12 21 12 21Z" />
      <circle cx="12" cy="9.2" r="2.25" />
    </svg>
  )
}

export function OrganizationIcon({ className }: IconProps) {
  return (
    <svg {...base} className={className}>
      <rect x="4" y="3" width="16" height="18" rx="1.25" />
      <path d="M9 8h1M9 12h1M9 16h1M14 8h1M14 12h1M14 16h1" />
    </svg>
  )
}

export function AccountIcon({ className }: IconProps) {
  return (
    <svg {...base} className={className}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="10.2" r="3" />
      <path d="M6.2 18.5c1.2-2.4 3.4-3.8 5.8-3.8s4.6 1.4 5.8 3.8" />
    </svg>
  )
}
